import { MagnifyingGlassIcon as PhosphorMagnifyingGlassIcon } from "@phosphor-icons/react/dist/ssr/MagnifyingGlass";

import { createAppIcon } from "@/components/createAppIcon";

export const SearchIcon = /* @__PURE__ */ createAppIcon(PhosphorMagnifyingGlassIcon);
